import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

export const getAuthZoneID = () => {
	const { zoneID } = window.lt.pageProperties?.auth || ({} as ltFramework.IAuthPageProperties);
	return zoneID;
};
